import { State, Action, StateContext, Selector } from '@ngxs/store';
import { UpdateUserInfoAction, LogoutAction, LoginAction, UpdateReturnUrlAction } from './settings.actions';
import { UserInfo } from '../_models/user-info';
import { Injectable, inject } from '@angular/core';
import { AuthService } from '../_services/auth.service';
import { tap } from 'rxjs/operators';

export class SettingsStateModel extends UserInfo {
}
export class ReturnUrlStateModel {
  returnUrl?: string
}

@State<SettingsStateModel>({
  name: 'settings',
  defaults: new UserInfo()
})
@Injectable()
export class SettingsState {
  private authService = inject(AuthService);


  @Selector()
  static isAuthenticated(state: SettingsStateModel): boolean {
    return !!state?.token;
  }

  @Selector()
  static userId(state: SettingsStateModel): string | undefined {
    return state?.id;
  }

  @Selector()
  static token(state: SettingsStateModel): string | undefined {
    return state?.token;
  }

  @Selector()
  static isAdmin(state: SettingsStateModel): boolean {
    return (state.roles && state.roles.includes('ADMIN')) || false;
  }

  @Selector()
  static isGask(state: SettingsStateModel): boolean {
    return state?.roles?.includes('GASK') || false;
  }

  @Selector()
  static isKhc(state: SettingsStateModel): boolean {
    return state?.roles?.includes('KHC') || false;
  }

  @Selector()
  static isKhcAdmin(state: SettingsStateModel): boolean {
    return state?.roles?.includes('KHC-ADMIN') || false;
  }

  @Selector()
  static isKds(state: SettingsStateModel): boolean {
    return state?.roles?.includes('KDS') || false;
  }

  @Selector()
  static isCertificationUnit(state: SettingsStateModel): boolean {
    return state?.roles?.includes('CERTIFICATION_UNIT') || false;
  }

  @Selector()
  static isDemo(state: SettingsStateModel): boolean {
    return state?.roles?.includes('DEMO') || false;
  }

  @Selector()
  static isSupport(state: SettingsStateModel): boolean {
    return state?.roles?.includes('SUPPORT') || false;
  }

  @Selector()
  static isOrganizationHeader(state: SettingsStateModel): boolean {
    let isHeader = false;
    if (state?.roles) {
      for (const role of state.roles) {
        if (role.startsWith('HEAD-BIN')) {
          isHeader = true;
        }
      }
    }
    return isHeader;
  }

  @Selector()
  static roles(state: SettingsStateModel): string[] {
    return state?.roles || [];
  }

  @Selector()
  static returnUrl(state: ReturnUrlStateModel): string | undefined {
    return state?.returnUrl;
  }

  @Action(UpdateUserInfoAction)
  updateUserInfo(ctx: StateContext<SettingsStateModel>, action: UpdateUserInfoAction) {
    const userInfo = action.payload;
    ctx.setState(userInfo);
  }

  @Action(LogoutAction)
  logout(ctx: StateContext<SettingsStateModel>, action: LogoutAction) {
    console.log('logout');
    ctx.setState(new UserInfo());
  }

  @Action(LoginAction)
  login(ctx: StateContext<SettingsStateModel>, action: LoginAction) {
    return this.authService.login(action.payload).pipe(
      tap((result: UserInfo) => {
        ctx.setState(result);
      })
    );
  }

  @Action(UpdateReturnUrlAction)
  setReturnUrl(ctx: StateContext<ReturnUrlStateModel>, action: UpdateReturnUrlAction) {
    console.log('setReturnUrl=' + action.payload?.returnUrl);
    const returnUrlState = action.payload;
    ctx.setState(returnUrlState);
  }
}
